import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

function BackButtons(props) {
  const history = useHistory();

  const handleClick = useCallback(() => {
    history.goBack();
  }, [])
  
  return (
    <button
      className="btn_exit"
      type="button"
      onClick={handleClick}
    >
      <img className="hide_m" src={`${process.env.PUBLIC_URL}/static/images/icon/ic_back@2x.png`} alt="" />
      <img className="hide_pc hide_t" src={`${process.env.PUBLIC_URL}/static/images/icon/ic_back_dark.svg`} alt="" />
    </button>
  );
}

export default BackButtons;